import React from 'react';

// Styles
import styles from './index.module.sass';

export default function BannerText({ text }) {
  return <div className={styles.BannerText}>{text}</div>;
}
